<template>
  <el-dialog
  title="私域订单审核"
  :visible.sync="visibleDialog"
  width="424px"
  top="calc(50vh - 130px)"
  class="pop-dialog pop-private-audit"
  append-to-body>
  <el-form :model="form" :rules="rules" ref="form" label-width="80px" class="audit-con">
    <el-form-item label="审核结果" prop="auditResult">
      <el-radio-group v-model="form.auditResult">
        <!-- 审核结果: 2-通过, 3-驳回 -->
        <el-radio :label="2">审核通过</el-radio>
        <el-radio :label="3">审核驳回</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input
        type="textarea"
        :rows="5"
        placeholder="请输入备注信息…"
        v-model="form.remark">
      </el-input>
    </el-form-item>
  </el-form>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini" :loading="loading">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>
  export default {
    name:'popPrivateAudit',
    data () {
      return {
        visibleDialog:false,
        loading: false,
        orderNos:[],
        form: {
          auditResult: '',
          remark: '',
        },
        rules: {
          auditResult: [
            { required: true, message: '请选择审核结果', trigger: 'blur' },
          ]
        }
      }
    },

    methods: {
       // 私域审核
      show(orderNos) {
        this.orderNos = orderNos
        this.form = {
           auditResult: '',
           remark: '',
        }
        this.visibleDialog = true
      },
      // 确认修改
      onConfirm() {
         this.$refs.form.validate((valid) => {
          if (valid) {
            let postData = {
                orderNos:this.orderNos,
                auditResult:this.form.auditResult,
                auditRemark:this.form.remark
            }
            console.log('postData:',postData)
            this.loading = true
            this.$api.omsPrivateAudit(postData).then((res) => {
              if (res.code == 0) {
                // 一条数据直接弹,多条弹列表
                if(this.orderNos.length ==1){
                  let message = res.data.failReasons && res.data.failReasons[0]
                  if(res.data.successCount){ 
                    this.$message.success(message || '审核成功！')
                  }else{ 
                    this.$message.error(message || '审核失败！')
                  }
                }else if(this.orderNos.length > 1){
                    let batchNo =  res.data.batchNo
                    let data = {
                      title:'私域订单审核处理结果',
                      type:'privateAudit',
                      batchNo
                    }
                    this.$parent.$refs.popResultTable.show(data)
                }
                this.$emit('fetchData')
              }
            }).finally(() => {
              this.visibleDialog = false
              this.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    },
  }
</script>
<style lang='scss'>
.pop-private-audit{
  .audit-con{
    padding: 20px 0 0 0;
    
  }
}
</style>